import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import { GenericNoData } from "../generic/GenericNoData";
import { UsersThree } from "@phosphor-icons/react";

// Based on UI design and old code from there table
const CustomDataGrid = styled(DataGrid)(({ theme }) => ({
  border: "1px solid #e6ecf1",
  borderRadius: "16px",

  "& .MuiDataGrid-filler": {
    border: "none !important",
    "--rowBorderColor": "none !important",
  },
  "& .MuiDataGrid-withBorderColor": {
    border: "none !important",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 800,
  },
  "& .MuiDataGrid-columnHeader": {
    color: "#454F5B",
    fontSize: "14px",
    background: "#F9FAFB",
    padding: "0px 10px",
  },
  "& .MuiDataGrid-columnHeader:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon": {
    display: "none",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none !important",
  },
  "& .MuiDataGrid-cell": {
    fontSize: "14px",
    border: "none",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-row": {
    padding: "0px 5px",
    borderBottom: "1px solid #f5f6f7",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: theme.palette.background.lightBlue ?? "#E5F6FD",
    transition: "0.5s",
  },
}));

export default CustomDataGrid;

export const CustomNoResultsOverlay = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%" }}>
      {<GenericNoData icon={<UsersThree size={40} />} height={"100%"} label={"No creators found"} />}
    </Box>
  );
};
